import * as React from 'react';
import * as ReactHighcharts from 'react-highcharts';

interface IFoundationMarkIndexLineProps {
  displayClickHere?: boolean;
  monthNumber?: string;
}

export class FoundationMarkIndexLine extends React.Component<IFoundationMarkIndexLineProps, {}> {
  state = {
    givData: [],
    foundationMarkData: [],
    categories: [],
  };

  componentDidMount() {
    this.pullData(this.props.monthNumber);
  }

  pullData(monthNumber?: string) {
    const month = monthNumber || '12';
    const givTrendFilterBody = {
      action: 'getFoundationMarkIndex',
      request: { assetLevel: 0, name: '', monthNumber: month, dateStart: '', dateEnd: '' },
    };

    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(givTrendFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        const fm = [];
        const giv = [];
        const categories = [];
        for (let period of json) {
          categories.push(period.indexDate);
          const datePieces = period.indexDate.split('-');
          const highlight = parseInt(datePieces[1]) == parseInt(monthNumber);
          fm.push({ y: period.foundationMarkIndex, color: highlight ? '#00B050' : '#2773B5' });
        }

        this.setState({ givData: giv, foundationMarkData: fm, categories });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.monthNumber !== this.props.monthNumber) {
      this.setState({ monthNumber: this.props.monthNumber }, () => {
        this.pullData(this.props.monthNumber);
      });
    }
  }

  getPublicIndexConfig(series, categories) {
    const { displayClickHere } = this.props;

    const title = displayClickHere
      ? '<b>Click <a style={{ color: "#333" }} href="#/fmindex">here</a> for more interactive visualizations</b>'
      : null;

    return {
      chart: { type: 'column', height: 575 },
      title: {
        text: title,
        style: {
          fontSize: '1.6rem',
          color: '#00B050',
        },
        floating: true,
        x: 75,
        y: 125,
        align: 'left',
        useHTML: true,
      },
      yAxis: {
        title: { text: 'Index', style: { fontWeight: 'bold' } },
        labels: {
          format: '{value}%',
          style: { fontWeight: 'bold' },
        },
      },
      xAxis: { categories },
      legend: {
        enabled: true,
        padding: 12,
        align: 'left',
        verticalAlign: 'top',
        layout: 'proximate',
        x: 75,
        y: 25,
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false,
          },
          label: {
            enabled: true,
          },
        },
        series: {
          events: {
            legendItemClick: function () {
              return false;
            },
          },
        },
      },
      tooltip: {
        headerFormat: '<b>{series.name}</b><br/>',
        pointFormat: '',
      },
      credits: {
        enabled: false,
      },
      series,
    };
  }

  getSeries() {
    const { foundationMarkData } = this.state;
    const series = [
      {
        name: 'FoundationMark Index',
        label: {
          enabled: true,
        },
        data: foundationMarkData,
      },
    ];

    return series;
  }

  render() {
    const { categories } = this.state;
    const series = this.getSeries();
    return <ReactHighcharts config={this.getPublicIndexConfig(series, categories)} ref="chart" />;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/FoundationMarkIndex/Line/index.tsx